// extracted by mini-css-extract-plugin
export default {"summary":"styles_summary__mH7Fk","details":"styles_details__TS0yt"};